import { accessRequestEmail } from "./supabaseConfig";

export function accessRequestLink(email = accessRequestEmail, recovery = false) {
  if (typeof email !== "string" || !/^[^\s@?&#]+@[^\s@?&#]+\.[^\s@?&#]+$/.test(email)) return null;
  return `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent(recovery ? "Guitar Charts password reset request" : "Guitar Charts account request")}&body=${encodeURIComponent(recovery ? "Hello, please send me a password reset link for my Guitar Charts account.\n\nMy account email address is: \n" : "Hello, I would like an invitation to Guitar Charts.\n\nMy email address is: \n")}`;
}

const pending = new WeakMap();
// React Strict Mode replays effects. Share the in-flight exchange so a one-time
// account link is not consumed twice. Tokens and sessions never enter Redux.
export function acceptInvitation(client, tokenHash, type = "invite") {
  if (!["invite", "recovery"].includes(type)) return Promise.reject(new Error("Unsupported account link"));
  const key = `${type}:${tokenHash}`;
  let requests = pending.get(client);
  if (!requests) { requests = new Map(); pending.set(client, requests); }
  if (!requests.has(key)) {
    const promise = Promise.resolve().then(() => client.auth.verifyOtp({ token_hash: tokenHash, type }))
      .finally(() => requests.delete(key));
    requests.set(key, promise);
  }
  return requests.get(key);
}
